import assetPath from '/app/packages/lebenslauf/articles/src/assets/von-selbststaendig-zu-unwiderstehlich-so-praesentierst-du-dich-im-lebenslauf.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')